module.exports = __webpack_public_path__ + "img/Pengiriman.7e65e8ef.svg";